<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div>
          <div class="title">璇宝语音管理</div>
          <div class="muted">上传 MP3/M4A/WAV 等音频，APP 首页可播放，也可在安卓端尝试设置为铃声。</div>
        </div>
        <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
      </div>

      <el-form :model="form" label-width="110px" class="voice-form">
        <el-form-item label="上传语音">
          <el-upload
            action="/api/admin/app/voice/upload"
            :headers="uploadHeaders"
            :show-file-list="false"
            accept=".mp3,.m4a,.aac,.wav,.ogg,.flac"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
          >
            <el-button type="primary" icon="el-icon-upload">选择音频文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="语音标题">
          <el-input v-model="form.title" placeholder="例如：璇宝晚安"></el-input>
        </el-form-item>
        <el-form-item label="音频地址">
          <el-input v-model="form.url" placeholder="上传后自动填入"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" style="width: 180px"></el-input-number>
          <span class="muted inline-tip">数字越大越靠前</span>
        </el-form-item>
        <el-form-item label="音频时长">
          <el-input-number v-model="form.duration" :min="0" style="width: 180px"></el-input-number>
          <span class="muted inline-tip">单位秒，可不填</span>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用"></el-switch>
        </el-form-item>
        <el-form-item label="文件信息">
          <div class="muted">文件：{{ form.file_name || "-" }}，大小：{{ form.file_size || 0 }} bytes</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark" :rows="3" placeholder="后台备注，不会重点展示"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存语音</el-button>
          <el-button @click="resetForm">清空</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border height="42vh">
        <el-table-column label="标题" width="180" prop="title"></el-table-column>
        <el-table-column label="试听" width="260">
          <template slot-scope="scope">
            <audio :src="scope.row.url" controls preload="none" style="width: 230px"></audio>
          </template>
        </el-table-column>
        <el-table-column label="音频地址" min-width="260">
          <template slot-scope="scope">
            <el-link :href="scope.row.url" target="_blank" type="primary">{{ scope.row.url }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="80" prop="sort"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'">{{ Number(scope.row.status) === 1 ? "启用" : "停用" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.updated_at || scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="130" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess } from "./appAdminUtils.js";

export default {
  name: "appVoice",
  data() {
    return {
      list: [],
      form: this.emptyForm(),
    };
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem("token") || "",
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    formatTime,
    emptyForm() {
      return {
        id: "",
        title: "",
        url: "",
        file_name: "",
        file_size: 0,
        duration: 0,
        sort: 0,
        status: 1,
        remark: "",
      };
    },
    getList() {
      post("/api/admin/app/voice/list", {}).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "语音列表获取失败");
        }
      });
    },
    beforeUpload(file) {
      const ok = /\.(mp3|m4a|aac|wav|ogg|flac)$/i.test(file.name);
      if (!ok) {
        this.$message.error("只能上传 mp3/m4a/aac/wav/ogg/flac 音频文件");
      }
      return ok;
    },
    uploadSuccess(res) {
      if (res.code !== 1001) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      const data = res.data || res;
      this.form.url = data.url;
      this.form.file_name = data.file_name;
      this.form.file_size = data.file_size;
      if (!this.form.title && data.file_name) {
        this.form.title = data.file_name.replace(/\.[^.]+$/, "");
      }
      this.$notify({ title: "上传成功", message: "语音文件信息已填入", type: "success" });
    },
    save() {
      if (!this.form.title || !this.form.url) {
        this.$message.error("请填写标题并上传音频");
        return;
      }
      post("/api/admin/app/voice/save", this.form).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.resetForm();
          this.getList();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    edit(row) {
      this.form = Object.assign(this.emptyForm(), row);
    },
    resetForm() {
      this.form = this.emptyForm();
    },
    remove(row) {
      this.$confirm(`确定删除语音「${row.title}」吗？`, "提示", { type: "warning" }).then(() => {
        post("/api/admin/app/voice/delete", { id: row.id }).then((res) => {
          if (isSuccess(res)) {
            this.$notify({ title: "删除成功", message: res.data.msg, type: "success" });
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.title {
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.inline-tip {
  margin-left: 12px;
}
.voice-form {
  max-width: 860px;
  margin-bottom: 20px;
}
.danger {
  color: #f56c6c;
}
</style>
